export const TranslationsBN = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
        hi: 'हिन्दी',
        ko: '한국어',
        ru: 'Русский',
        tr: 'Türkçe',
        nl: 'Nederlands',
        pl: 'Polski',
        ms: 'Bahasa Melayu',
        ro: 'Română',
        cs: 'Čeština',
        hu: 'Magyar',
        ta: 'தமிழ்',
        te: 'తెలుగు',
        bn: 'বাংলা',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
        hi: 'HI',
        ko: 'KO',
        ru: 'RU',
        tr: 'TR',
        nl: 'NL',
        pl: 'PL',
        ms: 'MS',
        ro: 'RO',
        cs: 'CS',
        hu: 'HU',
        ta: 'TA',
        te: 'TE',
        bn: 'BN',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
        hi: 'HIN',
        ko: 'KOR',
        ru: 'RUS',
        tr: 'TUR',
        nl: 'NLD',
        pl: 'POL',
        ms: 'MSA',
        ro: 'RON',
        cs: 'CES',
        hu: 'HUN',
        ta: 'TAM',
        te: 'TEL',
        bn: 'BEN',
    },
    // BASE
    phrases: {
        order_online: 'অনলাইনে অর্ডার করুন',
        cart: 'কার্ট',
        open_24: '24 ঘন্টা',
        closed: 'বন্ধ',
        free: 'বিনামূল্যে',
        something_went_wrong: 'কিছু ভুল হয়েছে',
        try_again: 'আবার চেষ্টা করুন',
    },
    constants: {
        calendar: {
            days: {
                monday: 'সোমবার',
                tuesday: 'মঙ্গলবার',
                wednesday: 'বুধবার',
                thursday: 'বৃহস্পতিবার',
                friday: 'শুক্রবার',
                saturday: 'শনিবার',
                sunday: 'রবিবার',
            },
        },
        services: {
            pickup: 'পিকআপ',
            delivery: 'ডেলিভারি',
            dine_in: 'ডাইন-ইন',
            table_booking: 'টেবিল বুকিং',
        },
        payment: {
            method: {
                cash: 'ক্যাশ',
                card: 'কার্ড',
                stripe: 'Credit Card',
                paypal: 'PayPal',
                cardconnect: 'Credit Card',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                razor_pay: 'Razor Pay',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                custom: 'Custom',
                red_dot: 'Red Dot Payment',
                gkash: 'Gkash',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Wallet',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                authorized: 'Authorize.net'
            },
            // BACKENDMETHODNAMES
            backend_method: {
                cash: 'ক্যাশ',
                card: 'কার্ড',
                stripe: 'Stripe',
                paypal: 'PayPal',
                cardconnect: 'CardConnect',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                bambora_na: 'Worldline',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                stripe_digital_wallet: 'Google/Apple Pay',
                razor_pay: 'Razor Pay',
                gravity: 'Gravity',
                authorized: 'Authorize.net',
                elavon: 'Elavon',
                red_dot: 'Red Dot Payment',
                gkash: 'Gkash',
                custom: 'Custom',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Wallet',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                nuvei: 'Nuvei',
                ONLINE: 'Online',
                online: 'Online'
            },
            status: {
                success: 'সফলতা',
                pending: 'মুলতুবি',
                error: 'ত্রুটি',
                refunded: 'ফেরত দেওয়া হয়েছে',
                refunding: 'রিফান্ডিং',
                partial_refunded: 'আংশিকভাবে ফেরত দেওয়া হয়েছে',
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: 'সরান',
                drop_here: 'আপনার ফাইলগুলি এখানে ড্রপ করুন বা একটি নির্বাচন করতে ক্লিক করুন৷',
                accepts: '{{fileTypes}} ফাইল গ্রহণ করে',
                errors: {
                    max_files: 'সর্বাধিক {{number}} অনুমোদিত',
                    max_size: 'সর্বোচ্চ ফাইলের আকার {{kilobytes}} KB',
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: 'দোকান বর্তমানে বন্ধ রয়েছে এবং একটি ডাইন-ইন অর্ডার দ্রুত রাখা সম্ভব নয়। আপনি একটি পরের তারিখ এবং সময়ে অর্ডার করতে পারেন',
            },
            buttons: {
                order: {
                    book_order: 'বুক টেবিল/অনলাইনে অর্ডার করুন',
                    order_online: 'অনলাইনে অর্ডার করুন',
                    book_table: 'একটি টেবিল বুক',
                    order: 'অর্ডার',
                    book: 'বই',
                    cart: 'কার্ট',
                    restart: 'রিস্টার্ট করুন',
                    closed: 'দোকান বন্ধ',
                    not_accepting: 'আদেশ গ্রহণ না',
                },
            },
        },
        modals: {
            auth: {
                login: 'লগইন করুন',
                register: 'নিবন্ধন করুন',
                register_commence: 'চালিয়ে যান',
                register_complete: 'অ্যাকাউন্ট তৈরি করুন',
                register_confirmation_sent: 'আপনার ইমেল ঠিকানায় একটি নিশ্চিতকরণ কোড পাঠানো হয়েছে। অনুগ্রহ করে নীচে লিখুন প্রস্থান করতে',
                register_confirmation_resent: 'নিশ্চিতকরণ কোড পুনরায় পাঠানো হয়েছে, আপনার স্পাম দেখুন বা প্রক্রিয়া পুনরায় শুরু করুন',
                register_restart: 'রিস্টার্ট করুন',
                register_resend_code: 'কোড পুনরায় পাঠান',
                register_confirmation_code_subject: 'ই-মেইল নিশ্চিতকরণ কোড',
                register_confirmation_code_email: 'আপনার ইমেল নিশ্চিতকরণ কোড হল {{confirmation_code}} (24 ঘন্টার মধ্যে মেয়াদ শেষ হবে)',
                login_placeholder: 'ই-মেইল',
                password_placeholder: 'পাসওয়ার্ড',
                confirm_password_placeholder: 'পাসওয়ার্ড নিশ্চিত করুন',
                confirmation_code_placeholder: 'ই-মেইল নিশ্চিতকরণ কোড',
                accept_terms: 'শর্তাবলী স্বীকার করুন',
                accept_terms_view: 'দেখুন',
                login_facebook: 'ফেসবুক দিয়ে লগইন করুন',
                login_google: 'গুগল দিয়ে লগইন করুন',
                benefits: 'আপনার সমস্ত অর্ডার সংরক্ষণ করতে লগইন করুন বা একটি অ্যাকাউন্ট তৈরি করুন',
                logged_in: 'সফলভাবে লগ ইন',
                logged_out: 'লগ আউট',
                password_reset: {
                    init_button: 'পাসওয়ার্ড রিসেট মেল পাঠান',
                    init_success: 'পাসওয়ার্ড রিসেট লিঙ্ক আপনার ই-মেইল পাঠানো হয়েছে',
                    complete_button: 'পাসওয়ার্ড রিসেট করুন',
                    complete_success: 'পাসওয়ার্ড সফলভাবে রিসেট করুন, আপনার নতুন পাসওয়ার্ড দিয়ে লগইন করুন',
                    forgot_password_text: 'আপনার পাসওয়ার্ড ভুলে গেছেন?',
                    forgot_password_link: 'পাসওয়ার্ড রিসেট করুন',
                    remember_password_text: 'আপনার পাসওয়ার্ড মনে আছে?',
                    remember_password_link: 'ফিরে যান',
                    invalid_title: 'পাসওয়ার্ড রিসেট অবৈধ৷',
                    invalid_description: 'এই পাসওয়ার্ড রিসেট লিঙ্কটি বৈধ নয়, পরিবর্তে একটি নতুন অনুরোধ করুন৷',
                    invalid_link: 'লগইন এ যান',
                    title: 'পাসওয়ার্ড রিসেট',
                    description: 'আপনার অ্যাকাউন্টের জন্য একটি নতুন পাসওয়ার্ড লিখুন',
                },
                error_generic: 'কিছু ভুল হয়েছে, অনুগ্রহ করে আবার চেষ্টা করুন বা আমাদের সাথে যোগাযোগ করুন',
                error_accept_terms: 'নিয়ম ও শর্তাবলী গ্রহণ করুন',
                error_password_length: 'পাসওয়ার্ডের জন্য ন্যূনতম 6 অক্ষর',
                error_social: 'কিছু ভুল হয়েছে, আবার চেষ্টা করুন বা আমাদের সাথে যোগাযোগ করুন',
                error_confirmation_code: 'অবৈধ নিশ্চিতকরণ কোড',
                error_invalid_code: 'অবৈধ নিশ্চিতকরণ কোড',
                error_exists: 'ব্যবহারকারী ইতিমধ্যেই বিদ্যমান',
                error_invalid_email_pass: 'অবৈধ ই-মেইল ঠিকানা বা পাসওয়ার্ড',
                error_password_no_match: 'পাসওয়ার্ড একে অপরের সাথে মেলে না',
                error_user_not_found: 'সেই ই-মেইল ঠিকানা সহ কোন ব্যবহারকারী নেই',
                error_invalid_email: 'অবৈধ ই-মেইল ঠিকানা',
                error_invalid_reset_token: 'অবৈধ রিসেট লিঙ্ক, অন্য একটি অনুরোধ',
            },
            booking: {
                form: {
                    name: 'পুরো নাম',
                    email: 'ই-মেইল ঠিকানা',
                    phone: 'ফোন নম্বর',
                    number_of_people: 'মানুষের সংখ্যা',
                    number_of_people_max: 'লোক সংখ্যা ({{max_people}} সর্বোচ্চ)',
                    number_of_people_min: 'মানুষের সংখ্যা ({{min_people}} মিনিট)',
                    number_of_people_max_min: 'মানুষের সংখ্যা ({{min_people}} থেকে {{max_people}} এর মধ্যে)',
                    notes: 'নোট / বিশেষ অনুরোধ',
                    submit: 'বুকিং অনুরোধ জমা দিন',
                    email_optional: '(ঐচ্ছিক)',
                    date: 'তারিখ',
                    duration: 'সময়কাল',
                    seating: 'উপলভ্য সময়',
                    number_of_guests: 'অতিথির সংখ্যা',
                    notes_placeholder: 'অ্যালার্জি, উপলক্ষ, আসনের পছন্দ',
                    reserving: 'সংরক্ষণ হচ্ছে...',
                    reserve_table: 'টেবিল বুক করুন',
                    please_choose_a_date_and_time: 'অনুগ্রহ করে একটি তারিখ ও সময় বেছে নিন।',
                    invalid_people: 'জনসংখ্যা {{min}} থেকে {{max}} এর মধ্যে হতে হবে।',
                    party_size_max_fallback: 'অনুমোদিত সর্বোচ্চ',
                    loading_available_times: 'উপলভ্য সময় লোড হচ্ছে…',
                    select_a_date_to_see_available_times: 'উপলভ্য সময় দেখতে একটি তারিখ বেছে নিন।',
                    no_times_available_for_this_date: 'এই তারিখে কোনো সময় নেই। অনুগ্রহ করে অন্য দিন বেছে নিন।',
                    shift: 'শিফট',
                    service_times: 'সেবার সময়',
                    new_shift: 'নতুন শিফট',
                    time: 'সময়',
                    times: 'সময়',
                    unavailable: 'অনুপলব্ধ',
                    available: 'উপলব্ধ',
                    required_name: 'অনুগ্রহ করে আপনার নাম লিখুন।',
                    required_phone: 'অনুগ্রহ করে আপনার ফোন নম্বর লিখুন।',
                    required_email: 'অনুগ্রহ করে আপনার ইমেল লিখুন।',
                    invalid_email: 'অনুগ্রহ করে একটি বৈধ ইমেল লিখুন।',
                    required_terms: 'বুক করার আগে শর্তাবলি গ্রহণ করুন।',
                    reservation_is_unavailable: 'রিজার্ভেশন উপলব্ধ নয়।',
                    please_contact_the_restaurant_directly: 'অনুগ্রহ করে রেস্তোরাঁর সাথে সরাসরি যোগাযোগ করুন।',
                    almost_done: 'প্রায় শেষ',
                    your_details: 'আপনার তথ্য',
                    tell_us_who_s_coming: 'কে আসছেন বলুন যাতে আমরা আপনার রিজার্ভেশন নিশ্চিত করতে পারি।',
                    book_your_table: 'আপনার টেবিল বুক করুন',
                    choose_a_time_that_works_for_you: 'আপনার সুবিধাজনক একটি সময় বেছে নিন।',
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: 'আপনার বুকিং অনুরোধ পাঠান, বাকিটা রেস্তোরাঁ সামলাবে।',
                    select_date: 'তারিখ বেছে নিন',
                    standard: 'সাধারণ',
                    minutes: 'মিনিট',
                    next: 'পরবর্তী →',
                    back: '← পেছনে',
                    accept_terms: 'আমি শর্তাবলি গ্রহণ করছি।',
                    info_1: 'আপনার বুকিং গৃহীত বা অস্বীকার করা হলে আপনি একটি ই-মেইল বিজ্ঞপ্তি পাবেন',
                },
                errors: {
                    not_found: "বুকিং নেই। হয়তো ডিলিট করা হয়েছে",
                    generic: 'কিছু ভুল হয়েছে, পৃষ্ঠাটি রিফ্রেশ করুন বা আমাদের সাথে যোগাযোগ করুন৷',
                    something_went_wrong: 'কিছু ভুল হয়েছে',
                    accept_terms: 'নিয়ম ও শর্তাবলী গ্রহণ করুন',
                    required_phone: 'আপনার ফোন নম্বর লিখুন',
                    required_email: 'আপনার ইমেল লিখুন',
                    required_zip: 'আপনার বিলিং জিপ কোড লিখুন',
                    required_name: 'আপনার নাম লিখুন',
                    invalid_email: 'অনুগ্রহ করে একটি বৈধ ই-মেইল ঠিকানা লিখুন',
                    invalid_phone: 'একটি বৈধ ফোন নম্বর লিখুন',
                    invalid_people: 'লোকেদের অবৈধ সংখ্যা',
                    missing_custom_fields: 'সমস্ত প্রয়োজনীয় ক্ষেত্র পূরণ করুন.',
                    booking_capacity_threshold: 'এই সময়ের জন্য আমরা পূর্ণ। অনুগ্রহ করে অন্য সময় চেষ্টা করুন।',
                    slot_unavailable: 'এই জনসংখ্যার জন্য আমরা পূর্ণ। অনুগ্রহ করে অন্য সময় চেষ্টা করুন।',
                    booking_date_paused: 'এই তারিখের বুকিং স্থগিত আছে। অনুগ্রহ করে অন্য দিন বেছে নিন।',
                    invalid_table_assignment: 'ওই টেবিলগুলোতে আপনার দল বসতে পারবে না। অনুগ্রহ করে অন্য সময় বেছে নিন।',
                    exceeded_order_limit: 'অনেক বেশি বুকিং অনুরোধ। অনুগ্রহ করে পরে আবার চেষ্টা করুন।',
                    validation_failed_recaptcha_v3: 'অস্বাভাবিক ট্রাফিক শনাক্ত হয়েছে। আপনি কি VPN ব্যবহার করছেন? উপরের যাচাই সম্পন্ন করে আবার চেষ্টা করুন।',
                    validation_failed_recaptcha_v2: 'বুকিং শুরু করা যায়নি। অনুগ্রহ করে আবার চেষ্টা করুন বা অন্য উপায় ব্যবহার করুন। VPN ব্যবহার করলে আগে সেটি বন্ধ করুন।',
                    booking_already_exists: 'এই রিজার্ভেশন আগেই পাঠানো হয়েছে। আপনার ইমেল দেখুন বা বুকিং লিঙ্ক খুলুন।',
                    invalid_party_size: 'অনুগ্রহ করে একটি বৈধ জনসংখ্যা বেছে নিন।',
                    invalid_request: 'অবৈধ অনুরোধ। অনুগ্রহ করে পেজ রিফ্রেশ করে আবার চেষ্টা করুন।',
                    table_booking_unavailable: 'টেবিল বুকিং উপলব্ধ নয়।',
                },
            },
            cart: {
                title: 'কার্ট',
                proceed_to_checkout: 'চেকআউট করতে এগিয়ে যান',
                edit_dish: 'সম্পাদনা করুন',
                remove_dish: 'সরান',
                no_items_1: 'কার্টে কোন আইটেম নেই',
                no_items_2: 'এগিয়ে যেতে প্রথমে কিছু যোগ করুন',
                free_delivery_notice: '{{value, currency}} এর বেশি অর্ডারের জন্য বিনামূল্যে বিতরণ',
                errors: {
                    min_order_promo: 'এই প্রচারটি প্রয়োগ করার আগে ন্যূনতম কার্ট মান {{value, currency}} প্রয়োজন৷',
                    min_order_delivery: 'ডেলিভারির জন্য ন্যূনতম কার্ট মান {{value, currency}}',
                },
                promo: {
                    heading: 'প্রচার কোড',
                    placeholder: 'আপনার প্রচার কোড লিখুন',
                    add: 'কোড যোগ করুন',
                    title: 'প্রোমো {{name}} কার্টে যোগ করা হয়েছে৷',
                    fixed_discount: '{{value, currency}} বন্ধ',
                    percent_discount: '{{value}}% ছাড়',
                    added_to_cart: 'প্রোমো কার্টে যোগ করা হয়েছে',
                    errors: {
                        not_found: 'প্রচার পাওয়া যায়নি',
                        disabled: 'প্রচার অক্ষম করা হয়েছে৷',
                        not_available: 'প্রচার বর্তমানে উপলব্ধ নেই',
                        not_eligible: 'প্রচারমূলক কোড প্রয়োগ করার যোগ্য নয়',
                        not_available_time: 'প্রোমো এই সময়ের জন্য প্রযোজ্য নয়',
                        logged_in_only: 'এই প্রচার ব্যবহার করতে লগ ইন করা আবশ্যক',
                        already_used: 'আপনি ইতিমধ্যে এই প্রচার ব্যবহার করেছেন',
                        invalid: 'এই প্রচার আর বৈধ নয়',
                        invalid_service: 'এই প্রচারটি আপনার নির্বাচিত পরিষেবার জন্য বৈধ নয়৷',
                        later_only: 'শুধুমাত্র প্রি-অর্ডারের জন্য বৈধ',
                        now_only: 'প্রি-অর্ডার নয় অবিলম্বে কারণে শুধুমাত্র আদেশের জন্য বৈধ',
                        generic: 'ওহো... কিছু ভুল হয়েছে এবং লগ করা হয়েছে৷',
                        dishes_required_multi: 'এই প্রচারটি শুধুমাত্র তখনই প্রযোজ্য হবে যখন কিছু নির্দিষ্ট আইটেম আপনার কার্টে যোগ করা হবে',
                        dishes_required_single: "এই প্রচারটি শুধুমাত্র তখনই প্রযোজ্য হবে যখন '{{dish}}' আপনার কার্টে যোগ করা হবে",
                    },
                },
                tip: {
                    title: 'অর্ডার টিপ',
                    placeholder: 'একটি অর্ডার টিপ যোগ করুন',
                },
            },
            free_items_promo: {
                title: 'বিনামূল্যে আইটেম',
                usage_confirmation: {
                    question: 'আপনি বিনামূল্যে আইটেম জন্য যোগ্য. আপনি তাদের দেখতে এবং যোগ করতে চান?',
                    cancellation: "না, আমি বিনামূল্যে আইটেম চাই না",
                    acceptance: 'হ্যাঁ',
                },
                free_items_selection: {
                    multiple: {
                        description: '{{number}} বিনামূল্যের আইটেম(গুলি) নির্বাচন করুন',
                    },
                    single: {
                        description: 'একটি বিনামূল্যে আইটেম নির্বাচন করুন',
                    },
                    confirm_button: 'নিশ্চিত করুন',
                },
            },
            checkout: {
                title: 'চেকআউট',
                subtitle: 'আপনার অর্ডার বিবরণ নিশ্চিত করুন',
                details: {
                    service: 'সেবা',
                    due: 'ডিউ',
                    due_now_asap: 'এখন / যত তাড়াতাড়ি সম্ভব',
                    address: 'ডেলিভারি ঠিকানা',
                    total: 'মোট',
                    table: 'টেবিল',
                    store_location: 'দোকানের ঠিকানা',
                },
                customer: {
                    title: 'গ্রাহক',
                    subtitle: 'আপনার অর্ডার এবং বিবরণ সংরক্ষণ করতে লগইন করুন',
                    button: 'লগইন করুন',
                    name: 'পুরো নাম',
                    email: 'ইমেইল',
                    phone: 'ফোন',
                    phone_important: 'ফোন (গুরুত্বপূর্ণ)',
                    notes: 'অর্ডার নোট',
                    delivery_notes: 'ডেলিভারি নির্দেশাবলী / অর্ডার নোট',
                    optional: 'ঐচ্ছিক',
                },
                payment: {
                    title: 'পেমেন্ট পদ্ধতি',
                    qr_modal_help: 'আপনার {{app}} মোবাইল অ্যাপ্লিকেশন ব্যবহার করুন এবং QR স্ক্যান করুন এবং এই অর্ডারের জন্য পেমেন্ট সম্পন্ন করুন। পেমেন্ট সম্পন্ন করার পর আপনার মোবাইল অ্যাপ্লিকেশনে, আপনি এই QR মডালটি বন্ধ করতে পারেন। আপনি যদি আপনার পেমেন্ট প্রক্রিয়া শেষ করা না হয়েছে তবে এই QR মডালটি বন্ধ করবেন না।',
                    switch_to_app_help: 'নীচের বোতামটি চাপুন, {{app}} মোবাইল অ্যাপ্লিকেশন স্বয়ংক্রিয়ভাবে খুলবে এবং এই অর্ডারের জন্য পেমেন্ট সম্পন্ন করবে। পেমেন্ট সম্পন্ন করার পর আপনার মোবাইল অ্যাপ্লিকেশনে, আপনি এই মডালটি বন্ধ করতে পারেন। আপনি যদি আপনার পেমেন্ট প্রক্রিয়া শেষ করা না হয়েছে তবে এই মডালটি বন্ধ করবেন না।',
                    open_app: '{{app}} অ্যাপ্লিকেশন খুলুন',
                    continue: 'চালিয়ে যান',
                    continue_to_payment: '{{method}} এ চালিয়ে যান',
                    back_to_cart: 'কার্টে ফিরে যান',
                },
                accept_terms: 'শর্তাবলী স্বীকার করুন',
                accept_terms_view: 'দেখুন',
                processing_order: 'প্রসেসিং অর্ডার',
                warning: {
                    different_payment_currency: 'দোকানের দামগুলি {{store_currency}} এর মধ্যে রয়েছে কিন্তু পেমেন্ট পদ্ধতি {{payment_currency}} এর মধ্যে রয়েছে',
                    closing_soon: 'শীঘ্রই বন্ধ হচ্ছে, অর্ডার অবশ্যই {{value}} মিনিটের মধ্যে স্থাপন করতে হবে',
                    closed: 'দুঃখিত, এই পরিষেবাটি বন্ধ হয়ে গেছে এবং অর্ডার গ্রহণ করা হচ্ছে না',
                    paused: 'দুঃখিত, এই পরিষেবাটি বিরাম দেওয়া হয়েছে এবং এই মুহূর্তে অর্ডারগুলি গ্রহণ করা হচ্ছে না৷',
                    expired: 'আমরা আর আপনার নির্বাচিত সময়ে আপনার অর্ডার পূরণ করতে পারবেন না. অনুগ্রহ করে পরবর্তী তারিখ বা সময় বেছে নিন',
                },
                errors: {
                    walletly_promo: 'Walletly প্রচারে ত্রুটি আছে, অনুগ্রহ করে আরেকটি প্রচার চেষ্টা করুন!',
                    stripe_generic: 'ক্রেডিট কার্ড ত্রুটি, আবার চেষ্টা করুন বা অন্য পদ্ধতি',
                    validation_failed: 'এই অর্থ প্রদান এই সময়ে গ্রহণ করা যাবে না. অনুগ্রহ করে পরে আবার চেষ্টা করুন বা অন্য অর্থপ্রদানের পদ্ধতি বেছে নিন।',
                    validation_failed_recaptcha_v3: 'অস্বাভাবিক ট্রাফিক শনাক্ত করা হয়েছে৷ আপনি কি ভিপিএন ব্যবহার করছেন? অনুগ্রহ করে উপরের চ্যালেঞ্জটি সম্পূর্ণ করুন এবং আবার চেষ্টা করুন।',
                    validation_failed_recaptcha_v2: 'আমরা পেমেন্ট শুরু করতে পারিনি। আবার চেষ্টা করুন বা অন্য পদ্ধতি ব্যবহার করুন. আপনি যদি একটি VPN ব্যবহার করেন তবে প্রথমে এটি বন্ধ করার চেষ্টা করুন।',
                    stripe_loading_fail: 'অর্থপ্রদানের ফর্ম লোড করার সময় ত্রুটি, অনুগ্রহ করে আবার চেষ্টা করুন৷',
                    something_went_wrong: 'কিছু ভুল হয়েছে',
                    paypal_generic: 'PayPal-এ কিছু ভুল হয়েছে, আবার চেষ্টা করুন বা অন্য পেমেন্ট পদ্ধতি বেছে নিন',
                    payment_fail: 'অর্থপ্রদান ব্যর্থ হয়েছে, অনুগ্রহ করে আবার চেষ্টা করুন বা অন্য অর্থপ্রদানের পদ্ধতি নির্বাচন করুন৷',
                    payment_cancelled: 'অর্থপ্রদান বাতিল হয়েছে, অনুগ্রহ করে আবার চেষ্টা করুন বা অন্য অর্থপ্রদানের পদ্ধতি নির্বাচন করুন',
                    payment_error: 'অনলাইন পেমেন্ট প্রক্রিয়াকরণে ত্রুটি, আবার চেষ্টা করুন বা অন্য অর্থপ্রদানের পদ্ধতি বেছে নিন',
                    payment_declined: 'আপনার অর্থপ্রদানের পদ্ধতি প্রত্যাখ্যান করা হয়েছে',
                    card_declined: "আপনার কার্ড প্রত্যাখ্যান করা হয়েছে এবং পেমেন্ট প্রক্রিয়া করা হয়নি",
                    promo_max_uses_exceeded: "এই প্রোমো কোডটি তার ব্যবহারের সীমায় পৌঁছেছে এবং আর উপলব্ধ নেই।",
                    store_closed: 'দোকান বন্ধ এবং আর অর্ডার গ্রহণ করা হয় না',
                    accept_terms: 'নিয়ম ও শর্তাবলী গ্রহণ করুন',
                    required_payment: 'একটি পেমেন্ট পদ্ধতি নির্বাচন করুন',
                    required_phone: 'আপনার ফোন নম্বর লিখুন',
                    required_email: 'আপনার ইমেল লিখুন',
                    required_zip: 'আপনার বিলিং জিপ কোড লিখুন',
                    required_name: 'আপনার নাম লিখুন',
                    invalid_email: 'অনুগ্রহ করে একটি বৈধ ই-মেইল ঠিকানা লিখুন',
                    invalid_phone: 'একটি বৈধ ফোন নম্বর লিখুন',
                    invalid_cc_number: 'আপনার ক্রেডিট কার্ড নম্বর অবৈধ',
                    invalid_order_amount: 'এই পেমেন্ট পদ্ধতির জন্য ন্যূনতম পরিমাণ প্রয়োজন',
                    retry_cc_number: 'কিছু ভুল হয়েছে, আপনার ক্রেডিট কার্ড নম্বর আবার লিখুন এবং আবার চেষ্টা করুন৷',
                    closed: 'দোকান বন্ধ এবং আদেশ গ্রহণ না',
                    promo_login_required: 'এই প্রচার ব্যবহার করতে লগ ইন করা আবশ্যক',
                    promo_used: 'আপনি ইতিমধ্যে এই প্রচার ব্যবহার করেছেন',
                    promo_by_payment_method_not_applicable: 'প্রোমো নির্বাচিত অর্থপ্রদানের পদ্ধতিতে প্রযোজ্য নয়।',
                    missing_custom_checkout_fields: 'সমস্ত প্রয়োজনীয় ক্ষেত্র পূরণ করুন.',
                    delivery_unavailable: 'ডেলিভারি পরিষেবা এই সময়ে উপলব্ধ না হতে পারে। অনুগ্রহ করে একটি পিক আপ অর্ডার করতে চান বাছাই করুন।',
                    required_delivery_provider: 'একটি পরিষেবা প্রদান চয়ন করুন.',
                    required_delivery_quotation: 'ডেলিভারি অনুমান মেয়াদ শেষ.',
                    exceeded_order_limit: 'আমরা এই মুহূর্তে অনেক অর্ডার পাচ্ছি। অনুগ্রহ করে পরবর্তী সময় বেছে নিন।',
                    exceeded_order_limit_later: 'আমরা আর আপনার নির্বাচিত সময়ে আপনার অর্ডার পূরণ করতে পারবেন না. অনুগ্রহ করে পরবর্তী তারিখ বা সময় বেছে নিন',
                },
                button: {
                    continue: 'পেমেন্ট চালিয়ে যান',
                    place_order: 'অর্ডার করুন',
                    update_order: 'অর্ডার আপডেট করুন',
                },
                delivery_estimation: {
                    title: 'ডেলিভারি অনুমান',
                    details: {
                        provider: 'ডেলিভারি প্রদানকারী',
                        estimated_fee: 'আনুমানিক ফি',
                        estimated_total_fee: 'ডেলিভারি ফি মোট',
                        estimated_discount_fee: 'ডেলিভারি ফি ডিসকাউন্ট',
                        previous_estimated_fee: 'পূর্ববর্তী আনুমানিক ফি',
                        tips: 'টিপস',
                        estimated_delivery_time: 'আনুমানিক ডেলিভারি সময়',
                        uber_new_estimation: 'নতুন অনুমান অনুরোধ',
                        uber_new_estimation_success: 'নতুন উবার ডেলিভারি অনুমান প্রয়োগ করা হয়েছে।',
                        uber_estimation_expired: 'ডেলিভারি অনুমান মেয়াদ শেষ',
                        uber_price: 'আমরা উবারের মূল্য ধরে রাখছি',
                        uber_need_time: 'আমি আরো সময় চাই',
                        lalamove_price: 'আমরা লালামোভ ডেলিভারি ফি ধরে রাখছি',
                        lalamove_new_estimation_success: 'নতুন Lalalmove ডেলিভারি অনুমান প্রয়োগ করা হয়েছে।',
                        lalamove_estimation_expired: 'ডেলিভারি অনুমান মেয়াদ শেষ',
                        lalamove_need_time: 'আমি আরো সময় চাই',
                        lalamove_new_estimation: 'নতুন অনুমান অনুরোধ',
                    },
                    quotation_error: 'বিতরণ অনুমান গণনা করতে কিছু ভুল হয়েছে।',
                },
            },
            customer: {
                age_v: {
                    title: 'বয়স যাচাইকরণ',
                    required_for_items: 'নির্দিষ্ট কিছু আইটেম অর্ডার করতে হবে',
                    min_age: 'ন্যূনতম বয়স: {{age}} বছর',
                    est_time: 'আনুমানিক যাচাইকরণ সময়: {{time}} ঘন্টা',
                    upload_description: 'আপনার আইডি নীচে আপলোড করুন যাচাইকরণের জন্য। যাচাই করার পর আপনার জন্য e-mail দ্বারা জানানো হবে। আপলোড করুন আরো 2 ছবি, যার সর্বোচ্চ আকার 2 MB',
                    pending_description_1: 'আপনার ডকুমেন্ট জমা করার জন্য ধন্যবাদ। আপনি অনুমোদিত হলে e-mail দ্বারা জানানো হবে',
                    pending_description_2: 'আপনার যাচাইকরণ অবস্থা আপডেট করতে পৃষ্ঠাটি রিফ্রেশ করুন। আনুমানিক যাচাইকরণ সময় {{time}} ঘন্টা',
                    approved_description: 'আপনার অ্যাকাউন্ট যাচাই করা হয়েছে এবং আপনি সীমাবদ্ধ মেনু থেকে অর্ডার করতে পারেন',
                    rejected_description: 'আপনার আইডি প্রত্যাখ্যান করা হয়েছে. আপনি যদি আবার চেষ্টা করতে চান তাহলে আপনার আইডি আবার আপলোড করুন',
                    upload: 'আপলোড করুন',
                    reupload: 'ডকুমেন্ট পুনরায় আপলোড করুন',
                    go_back: 'ফিরে যান',
                    view_document: 'নথি দেখুন {{number}}',
                    status: {
                        unverified: 'যাচাই করা হয়নি',
                        pending: 'অনুমোদনের জন্য অপেক্ষা করছে',
                        approved: 'সফলভাবে যাচাই করা হয়েছে',
                        rejected: 'প্রত্যাখ্যাত',
                    },
                },
                headings: {
                    sessions: 'সেশন',
                    orders: 'অর্ডার',
                    spend: 'খরচ করুন',
                    order_history: 'অর্ডার ইতিহাস',
                    loyalty: 'আনুগত্য',
                    loyalty_points: 'আনুগত্য পয়েন্ট',
                    added: 'প্রচার যোগ করা হয়েছে.',
                },
                loyalty_errors: {
                    invalid_cart_items: 'ভাঙ্গার আগে যে কোনো আইটেম চয়ন করুন!',
                    not_found: 'প্রোমো পাওয়া যায়নি!',
                    already_exists: 'প্রচার ইতিমধ্যেই বিদ্যমান!',
                    try_again: 'এই চুক্তি প্রয়োগ করতে পারবেন না. আবার চেষ্টা করুন!',
                },
            },
            custom_payment: {
                title: '{{name}} পেমেন্ট ফর্ম',
                description: 'আপনি আমাদের অনলাইন পেমেন্ট ফর্মে পৌছে গিয়েছেন। অনুগ্রহ করে নীচের ফিল্ডস পূরণ করুন একটি পেমেন্ট করতে। যদি কোনো পরিমাণ লিখনা হয় তাহলে আপনার বিবরণ সংরক্ষিত হয়েছে কিন্তু আপনার কোনো চার্জ করা হবে না।',
                disabled: 'এই অনলাইন পেমেন্ট পৃষ্ঠাটি সঠিকভাবে কনফিগার করা হয়নি। অনুগ্রহ করে সাইট মালিককে যোগাযোগ করুন ত্রুটি সমাধান করতে।',
                success: 'আপনার অর্থপ্রদান সফলভাবে প্রক্রিয়া করা হয়েছে এবং আপনার বিবরণ সংরক্ষিত হয়েছে। ধন্যবাদ',
                back: 'বাড়িতে ফিরে যান',
                fields: {
                    name: 'পুরো নাম',
                    email: 'ই-মেইল ঠিকানা',
                    reference: 'পেমেন্ট রেফ.',
                    amount: 'পরিমাণ ($)',
                    name_on_card: 'কার্ডে নাম',
                    submit: 'পেমেন্ট জমা দিন',
                },
                warning: {
                    currency: 'দ্রষ্টব্য: {{actual}} এ অর্থপ্রদানের পরিমাণ, {{default}} নয়',
                },
                errors: {
                    generic: 'কিছু ভুল হয়েছে, আবার চেষ্টা করুন বা আমাদের সাথে যোগাযোগ করুন',
                    stripe_generic: 'ক্রেডিট কার্ডের ত্রুটি, পৃষ্ঠাটি রিফ্রেশ করুন এবং আবার চেষ্টা করুন',
                    payment_fail: 'অর্থপ্রদান ব্যর্থ হয়েছে, অনুগ্রহ করে আবার চেষ্টা করুন বা অন্য অর্থপ্রদানের পদ্ধতি নির্বাচন করুন৷',
                    payment_cancelled: 'অর্থপ্রদান বাতিল হয়েছে, অনুগ্রহ করে আবার চেষ্টা করুন বা অন্য অর্থপ্রদানের পদ্ধতি নির্বাচন করুন',
                    payment_error: 'অনলাইন পেমেন্ট প্রক্রিয়াকরণে ত্রুটি, আবার চেষ্টা করুন বা অন্য অর্থপ্রদানের পদ্ধতি বেছে নিন',
                    payment_declined: 'আপনার অর্থপ্রদানের পদ্ধতি প্রত্যাখ্যান করা হয়েছে',
                    card_declined: "আপনার কার্ড প্রত্যাখ্যান করা হয়েছে এবং পেমেন্ট প্রক্রিয়া করা হয়নি",
                    promo_max_uses_exceeded: "এই প্রোমো কোডটি তার ব্যবহারের সীমায় পৌঁছেছে এবং আর উপলব্ধ নেই।",
                },
            },
            dish: {
                add: 'কার্টে যোগ করুন',
                edit: 'আইটেম আপডেট করুন',
                notes: 'বিশেষ নির্দেশনা...',
                ingredients: {
                    title: 'উপকরণ',
                    uncheck_remove: 'সরাতে আন-চেক করুন',
                },
                ingredients_title: 'উপকরণ',
                combo: {
                    choose_dish: 'একটি আইটেম চয়ন করুন',
                },
                option_sets: {
                    conditions: {
                        select_one: 'একটি নির্বাচন করুন (প্রয়োজনীয়)',
                        select_one_optional: 'একটি নির্বাচন করুন (ঐচ্ছিক)',
                        select_between: '{{min}} - {{max}} এর মধ্যে নির্বাচন করুন (প্রয়োজনীয়)',
                        select_at_least: 'অন্তত {{qty}} নির্বাচন করুন (প্রয়োজনীয়)',
                        select_up_to: '{{qty}} পর্যন্ত নির্বাচন করুন (ঐচ্ছিক)',
                        select_multiple_optional: 'একাধিক নির্বাচন করুন (ঐচ্ছিক)',
                        select_multiple: 'একাধিক নির্বাচন করুন (প্রয়োজনীয়)',
                        free_amount: 'প্রথম {{qty}} বিনামূল্যে / {{selected}} বেছে নেওয়া হয়েছে৷',
                    },
                    points: {
                        none_consumed: 'আপনি বিনামূল্যে সর্বাধিক {{maxFree}} বিকল্প চয়ন করতে পারেন৷',
                        less_than_total_points: 'আপনি বিনামূল্যে জন্য আরো বিকল্প বাছাই করতে পারেন',
                        greather_than_total_points: 'আপনি অতিরিক্ত চার্জের জন্য আরও বিকল্প বেছে নিতে পারেন',
                    },
                },
                error: 'অনুগ্রহ করে লাল রঙে চিহ্নিত যেকোনো বিকল্প সংশোধন করুন',
                added_to_cart: 'আইটেম কার্ট যোগ করা হয়েছে',
            },
            map: {
                zone_fee: 'ডেলিভারি ফি',
                view_in_google: 'গুগল ম্যাপে দেখুন',
            },
            portal_go_back: {
                title: 'রেস্টুরেন্ট অনুসন্ধানে ফিরে যান?',
                description: 'আপনার কার্টের যেকোনো আইটেম হারিয়ে যাবে',
                cancel: 'বাতিল করুন',
                proceed: 'ফিরে যান',
            },
            order: {
                config: {
                    services: {
                        title: 'একটি পরিষেবা চয়ন করুন',
                        table_booking: 'বইয়ের টেবিল',
                    },
                    address_custom: {
                        input_placeholder: 'আপনার ঠিকানা লিখুন',
                    },
                    address: {
                        input_placeholder: 'আপনার ডেলিভারি ঠিকানা খুঁজুন',
                        extras_placeholder: 'ইউনিট নম্বর, বিল্ডিং নাম, বিতরণ নির্দেশাবলী, ইত্যাদি...',
                        search_placeholder: 'আপনার ঠিকানা অনুসন্ধান করুন',
                        search_input_placeholder: 'অনুসন্ধান করতে টাইপ করুন',
                        no_address_found: 'কোন ঠিকানা পাওয়া যায়নি. 5টির বেশি অক্ষর টাইপ করার চেষ্টা করুন',
                        not_found: 'ডেলিভারি ঠিকানা পাওয়া যায়নি বা বৈধ, আবার চেষ্টা করুন',
                        not_delivering: 'আমরা বর্তমানে এই ঠিকানায় বিতরণ করছি না',
                        not_in_range: 'আপনার ঠিকানা আমাদের দোকান অবস্থান সীমার মধ্যে নেই',
                        not_in_zone: 'আপনার ঠিকানা একটি সক্রিয় বিতরণ অঞ্চলের মধ্যে নয়',
                        no_number: 'আপনার ঠিকানায় একটি রাস্তার নম্বর থাকতে হবে',
                        location_permission: 'এই ওয়েবসাইটটিকে আপনার বর্তমান অবস্থান অ্যাক্সেস করার অনুমতি দেবেন?',
                        location_permission_warning: "আপনার বর্তমান অবস্থান অ্যাক্সেস করা সম্ভব নয়। অনুগ্রহ করে আপনার ডিভাইস এবং ওয়েব ব্রাউজারে অবস্থান সক্ষম করুন। এখানে কিছু রেফারেন্স:",
                        pick_location: 'আপনার অবস্থান চয়ন করুন',
                        pick_location_help_text: 'মানচিত্রে অবস্থান চয়ন করতে মার্কারটি টেনে আনুন৷',
                        use_current_location: 'বর্তমান অবস্থান ব্যবহার করুন',
                        locate_on_map: 'মানচিত্রে অবস্থান করুন',
                    },
                    datetime: {
                        title: 'আপনি কখন আপনার অর্ডার চান',
                        due_now: 'এখন',
                        due_later: 'পরে',
                        service_not_available: 'দুঃখিত, আমরা বর্তমানে {{service}} এর জন্য অর্ডার গ্রহণ করছি না',
                        currently_closed: '{{service}} বর্তমানে বন্ধ কিন্তু আপনি পরে অর্ডার করতে পারেন৷',
                        due_unavailable: 'অনুপলব্ধ',
                        due_closed: 'বন্ধ',
                        select_date: 'তারিখ নির্বাচন করুন',
                        select_time: 'সময় নির্বাচন করুন',
                        select_order_date: 'আপনার অর্ডার তারিখ নির্বাচন করুন',
                        select_order_time: 'আপনার অর্ডার সময় নির্বাচন করুন',
                        select_order_date_time: 'আপনার অর্ডারের তারিখ/সময় নির্বাচন করুন',
                        select_booking_date: 'আপনার বুকিং তারিখ নির্বাচন করুন',
                        select_booking_time: 'আপনার বুকিং সময় নির্বাচন করুন',
                        no_times_available: 'থেকে চয়ন করার জন্য কোন সময় উপলব্ধ',
                        date_today: '(আজ)',
                        date_closed: '(বন্ধ)',
                        date_bookings_paused: '(বুকিং স্থগিত)',
                        time_slot_closed: 'বন্ধ',
                    },
                    number_of_people: {
                        placeholder: 'মানুষের সংখ্যা',
                    },
                    table: {
                        select: 'টেবিল নির্বাচন করুন',
                        select_popup_title: 'আপনার টেবিল নির্বাচন করুন',
                        password: 'টেবিল পাসওয়ার্ড',
                        password_warning: 'এগিয়ে যেতে আপনার টেবিল পাসওয়ার্ড লিখুন',
                    },
                    warning: {
                        closed: 'দুঃখিত, আমরা বর্তমানে বন্ধ / কোনো আদেশ গ্রহণ করছি না',
                        not_available: 'দুঃখিত, আমরা বর্তমানে কোন আদেশ গ্রহণ করছি না',
                    },
                    eta: {
                        delivery: `আনুমানিক বিতরণ সময় প্রায় {{minutesToCustomer}} মিনিট`,
                        pickup: `অর্ডার প্রায় {{minutesToCustomer}} মিনিটের মধ্যে প্রস্তুত হয়ে যাবে`,
                    },
                    start_button: 'অর্ডার শুরু করুন',
                },
                history: {
                    invalid: 'অর্ডার পুনরায় করা সম্ভব নয় কারণ কিছু আইটেম অর্ডার করা হয়েছে এবং পরিবর্তিত হয়েছে অথবা বর্তমানে উপলব্ধ নয়',
                },
                reorder: {
                    title: 'দ্রুত রি-অর্ডার',
                    description: 'আপনার আগের অর্ডারগুলি থেকে সহজেই আইটেমগুলি অর্ডার করুন',
                },
            },
            receipt: {
                errors: {
                    not_found: 'অর্ডার পাওয়া যায়নি, পৃষ্ঠা রিফ্রেশ করুন এবং আবার চেষ্টা করুন',
                    booking_not_found: 'বুকিং বিদ্যমান নেই। সম্ভবত মুছে ফেলা হয়েছে',
                    generic: 'কিছু ভুল হয়েছে, পৃষ্ঠাটি রিফ্রেশ করুন বা আমাদের সাথে যোগাযোগ করুন৷',
                },
                connection: {
                    connected: 'রিয়েল-টাইম আপডেট',
                    connecting: 'রিয়েল-টাইম আপডেট সংযুক্ত হচ্ছে',
                    disconnected: 'রিয়েল-টাইম আপডেট সংযোগ বিচ্ছিন্ন',
                },
            },
            warnings: {
                logout: {
                    pretitle: 'সতর্কতা',
                    title: 'লগআউট',
                    body: 'লগ আউট করলে আপনার কার্টে যোগ করা যেকোনো আইটেম মুছে যাবে',
                    cancel: 'বাতিল করুন',
                    proceed: 'এগিয়ে যান',
                },
                order_restart: {
                    warning: 'সতর্কতা',
                    title: 'অর্ডারের বিবরণ পরিবর্তন করুন',
                    body: 'আপনার অর্ডারের বিবরণ পরিবর্তন করলে আপনার কার্টের আইটেমগুলি মুছে যাবে কারণ কিছু আইটেম অনুপলব্ধ হতে পারে',
                    cancel: 'বাতিল করুন',
                    proceed: 'এগিয়ে যান',
                },
                order_expired: {
                    subtitle: 'গুরুত্বপূর্ণ',
                    title: 'আদেশ অবিলম্বে কারণে পরিবর্তন',
                    description: 'আপনার অর্ডারের জন্য প্রদত্ত সময় এখন দূরে নয়। সুতরাং আপনার অর্ডারটি দ্রুত / এসএপ এর মধ্যে পরিবর্তিত হয়েছে',
                    button: 'ঠিক আছে',
                },
                order_expiring: {
                    subtitle: 'গুরুত্বপূর্ণ',
                    title: 'অর্ডারের সময়সীমা শীঘ্রই শেষ হচ্ছে',
                    description: 'আপনার অর্ডার {{time, timeFromTimestamp}} এর আগে দিতে হবে অন্যথায় এটি আর বৈধ হবে না',
                    button: 'ঠিক আছে',
                },
                location_permission: {
                    cancel: 'বাতিল করুন',
                    proceed: 'এগিয়ে যান',
                },
            },
            card_payment_authentication: {
                title: 'পেমেন্ট প্রমাণীকরণ',
                note: 'আপনি আপনার ব্যাঙ্ক থেকে প্রমাণীকরণ প্রক্রিয়া সম্পূর্ণ না করা পর্যন্ত অনুগ্রহ করে এই উইন্ডোটি খোলা রাখুন।',
            },
            maps: {
                cancel: 'বাতিল করুন',
                use_location: 'অবস্থান ব্যবহার করুন',
            },
            app_refresh: {
                refresh: 'রিফ্রেশ',
                title: 'রিফ্রেশ স্টোর',
                description: 'আমাদের দোকান একটি আপডেট অনুভব করেছে। অনুগ্রহ করে আপনার ব্রাউজারটি রিফ্রেশ করুন এবং সর্বশেষ সংস্করণে অ্যাক্সেস করুন। রিফ্রেশ করার পর আপনি যদি কার্টটি খুলতে চান তবে কার্টটি খুলুন এবং চেকআউট প্রক্রিয়া চালানোর জন্য এগিয়ে যান।',
            },
        },
        sections: {
            nav_top: {
                guest: 'অতিথি',
                login: 'লগইন করুন',
                login_signup: 'লগইন/সাইন আপ করুন',
                logout: 'লগআউট',
            },
            menus: {
                info: {
                    no_menus: 'বর্তমানে কোন মেনু উপলব্ধ নেই',
                    restrictions: 'মেনু সীমাবদ্ধতা',
                    not_available: 'মেনু অনুপলব্ধ৷',
                    unavailable: {
                        times: "মেনু অনুপলব্ধ, আপনার অর্ডার প্রয়োজনীয়তা নেই",
                        services: "মেনু অনুপলব্ধ, আপনার অর্ডার প্রয়োজনীয়তা নেই",
                        hours: 'মেনু অনুপলব্ধ, আপনার অর্ডার ঘন্টা এই মেনু উপলব্ধ ঘন্টার মধ্যে নেই',
                        pre_order: "মেনু অনুপলব্ধ, আপনার অর্ডার প্রয়োজনীয়তা নেই",
                        age: 'মেনু অনুপলব্ধ, এই মেনু থেকে অর্ডার করার জন্য আপনাকে অবশ্যই বয়স যাচাই করা অ্যাকাউন্ট দিয়ে লগ ইন করতে হবে',
                    },
                    services: {
                        title: 'অর্ডার প্রয়োজনীয়তা',
                        pickup: 'পিকআপ',
                        delivery: 'ডেলিভারি',
                        dine_in: 'ডাইন-ইনস',
                    },
                    times: {
                        now: 'কোনো প্রি-অর্ডার নেই',
                        later: 'শুধুমাত্র প্রি-অর্ডার',
                    },
                    hours: {
                        title: 'উপলব্ধ ঘন্টা',
                    },
                    preorder: {
                        title: 'প্রি-অর্ডার প্রয়োজনীয়তা',
                        days_in_advance: '{{days}} দিন আগে অর্ডার করতে হবে',
                        cutoff_time: 'শেষ দিনের কাট-অফ সময় {{time, timeFromTime}} এ',
                    },
                    age_restricted: {
                        title: 'বয়স সীমাবদ্ধ',
                        approved: 'আপনার অ্যাকাউন্ট যাচাই করা হয়েছে এবং আপনি এই মেনু থেকে অর্ডার করতে পারেন',
                        rejected: 'অর্ডার করার জন্য বয়স যাচাইকরণ প্রয়োজন। একটি অ্যাকাউন্ট তৈরি করুন এবং আপনার আইডি আপলোড করুন',
                    },
                },
                search: {
                    title: 'মেনু আইটেম অন্বেষণ',
                    no_result: 'কিছুই ফিরে আসেনি। অন্য একটি অনুসন্ধান শব্দ ব্যবহার করে দেখুন?',
                    placeholder: 'আপনি কি খুঁজছেন?',
                },
            },
            category: {
                restrictions: 'বিভাগ সীমাবদ্ধতা',
                not_available: 'বিভাগ অনুপলব্ধ',
                unavailable: {
                    services: "বিভাগ অনুপলব্ধ, আপনার অর্ডার প্রয়োজনীয়তা নেই",
                    hours: "বিভাগ অনুপলব্ধ, আপনার অর্ডার ঘন্টা এই বিভাগের উপলব্ধ ঘন্টার মধ্যে নেই",
                },
            },
            info: {
                location: {
                    title: 'অবস্থান',
                    view_map: 'মানচিত্র দেখুন',
                    phone: 'ফোন',
                },
                hours: {
                    title: 'খোলার সময়',
                    title_special: 'বিশেষ খোলার সময়',
                },
                services: {
                    title: 'সেবা',
                    notes: 'নোট',
                    delivery: {
                        ranges: 'ডেলিভারি রেঞ্জ',
                        zones: 'ডেলিভারি জোন',
                        view_zones: 'মানচিত্রে অঞ্চলগুলি দেখুন৷',
                        fee: 'ডেলিভারি ফি',
                        fee_short: 'ফি',
                        fee_varies: 'পরিবর্তিত হয়, কার্টে দেখানো হয়',
                        min_order: 'ন্যূনতম অর্ডার',
                        min_order_short: 'ন্যূ. অর্ড.',
                        no_min_order: 'ন্যূনতম অর্ডার নেই',
                        free_amount: 'ফ্রি ডেলিভারির পরিমাণ',
                    },
                },
            },
            contact: {
                title: 'আমাদের সাথে যোগাযোগ করুন',
                name: 'নাম',
                email: 'ই-মেইল',
                phone: 'ফোন নম্বর',
                message: 'আপনার বার্তা লিখুন...',
                send: 'বার্তা পাঠান',
                success: 'আপনার বার্তা সফলভাবে পাঠানো হয়েছে',
                error: 'কিছু ভুল হয়েছে, আবার চেষ্টা করুন বা পরে চেষ্টা করুন',
            },
            footer: {
                powered_by: 'দ্বারা চালিত',
                terms_and_conditions: 'শর্তাবলী',
                privacy: 'গোপনীয়তা নীতি',
                cookie: 'কুকি নীতি',
            },
        },
        pages: {
            payment_completed: {
                title: 'আপনার অর্থপ্রদান প্রক্রিয়া করা হয়েছে. আপনার আদেশের জন্য আপনাকে ধন্যবাদ!',
                subtitle: 'অর্ডার তথ্য আপনার ইমেল ঠিকানায় পাঠানো হয়েছে.',
                back_to_menu: 'মেনুতে ফিরে যান',
                close_tab: 'এই ট্যাবটি বন্ধ করুন',
            },
            payment_failed: {
                title: 'দুর্ভাগ্যবশত আপনার পেমেন্ট প্রক্রিয়া করার সময় একটি ত্রুটি ছিল।',
                subtitle: '',
                back_to_menu: 'মেনুতে ফিরে যান',
                close_tab: 'এই ট্যাবটি বন্ধ করুন',
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'বুকিং রসিদ',
            details: {
                datetime: 'জন্য বুকিং',
                number_of_people: 'মানুষের সংখ্যা',
                placed: 'স্থাপন করা হয়েছে',
                updated: 'সর্বশেষ আপডেট',
                notes: 'নোট',
                name: 'নাম',
                email: 'ই-মেইল',
                phone: 'ফোন',
                store_address: 'দোকানের ঠিকানা',
            },
            status_update: {
                title: 'বুকিং {{number}} আপডেট করা হয়েছে৷',
                body: 'আপনার বুকিং স্থিতি {{status}} এ আপডেট করা হয়েছে',
            },
            email_common: {
                name: 'নাম: {{name}}',
                phone: 'ফোন: {{number}}',
                number_of_people: 'ব্যক্তির সংখ্যা: {{number}}',
                date: 'তারিখ: {{date}}',
                time: 'সময়: {{time}}',
                location: 'স্টোরের অবস্থান: {{name}}',
                notes: 'নোট: {{name}}',
            },
            email_new_booking_restaurant: {
                subject: 'নতুন টেবিল বুকিং {{number}} দ্বারা {{name}}',
                powered_by: '{{name}} দ্বারা চালিত',
                overview: 'নতুন টেবিল বুকিং অনুরোধ',
                title: '{{name}} এর জন্য নতুন বুকিং',
                subtitle: 'বুকিং নম্বর {{number}}',
                description_confirmed: 'বুকিং স্বয়ংক্রিয়ভাবে নিশ্চিত করা হয়েছে। আপনি এটি অ্যাডমিন ড্যাশবোর্ডের মাধ্যমে বাতিল করতে পারেন এবং আপনার ক্লায়েন্ট ইমেলে জানানো হবে',
                description_unconfirmed: 'অ্যাডমিন ড্যাশবোর্ডের মাধ্যমে বুকিং নিশ্চিত করুন বা বাতিল করুন',
                url_pre_text: 'দেখুন এবং আপডেট করুন',
            },
            email_new_booking_customer: {
                subject: 'টেবিল বুকিং অনুরোধ',
                powered_by: '{{name}} দ্বারা চালিত',
                overview: 'নতুন টেবিল বুকিং অনুরোধ',
                title: 'আপনার বুকিং জন্য আপনাকে ধন্যবাদ',
                subtitle: 'বুকিং নম্বর {{number}}',
                description: '<b>আপনার বুকিং নিশ্চিত করা বা বাতিল করার পর আপনি অন্য একটি ইমেল পাবেন।</b><br>অনুগ্রহ করে আমাদের সাথে যোগাযোগ করুন আপনার বুকিং সম্পর্কে যেকোনো পরিবর্তন করতে। আপনার বুকিং সম্পর্কে বিস্তারিত তথ্য নিম্নলিখিত হয়:',
                url_pre_text: 'আপনি এখানে আপনার রিয়েল-টাইম বুকিং রসিদ দেখতে পারেন',
            },
            email_update_booking_customer: {
                subject_confirmed: 'টেবিল বুকিং নিশ্চিত করা হয়েছে',
                subject_unconfirmed: 'টেবিল বুকিং বাতিল করা হয়েছে',
                powered_by: '{{name}} দ্বারা চালিত',
                overview: 'টেবিল বুকিং অনুরোধ',
                title_confirmed: 'বুকিং নিশ্চিত করা হয়েছে',
                title_unconfirmed: 'বুকিং বাতিল',
                subtitle: 'বুকিং নম্বর {{number}}',
                description_confirmed: 'আমরা আপনাকে দেখতে চাই। অনুগ্রহ করে আমাদের সাথে যোগাযোগ করুন আপনার বুকিং সম্পর্কে যেকোনো পরিবর্তন করতে',
                description_unconfirmed: 'আমরা আপনাকে জানাতে অনুগ্রহ করি যে আপনার বুকিং অনুরোধ গ্রহণ করা সম্ভব নয়। আমরা আপনাকে দুর্ভাগ্যবশত জানাই। আপনার যদি কোনো প্রশ্ন থাকে তবে অনুগ্রহ করে আমাদের সাথে যোগাযোগ করুন',
                url_pre_text: 'আপনি এখানে আপনার রিয়েল-টাইম বুকিং রসিদ দেখতে পারেন',
            },
            email_status_update_customer: {
                subject: 'বুকিং #{{number}} – {{subjectLabel}}',
                body: '{{store}}-এ আপনার বুকিং #{{number}} এখন {{status}}।',
            },
            errors: {},
            status_warning: 'বুকিং পৃষ্ঠায় আপনার অ্যাডমিন ড্যাশবোর্ডে এই বুকিংয়ের স্ট্যাটাস আপডেট করুন',
        },
    },
    email_delayed_order: {
        subject: 'অর্ডার #{{number}} – {{subjectLabel}}',
        header: 'আপডেট করা প্রস্তুতির সময়',
        title: 'আপডেট করা প্রস্তুতির সময়',
        order_number: 'অর্ডার নম্বর: {{number}}',
        description: 'আপনার অর্ডার এখন {{time}}-এ প্রস্তুত হবে।',
        order_time_updated_to: 'আপনার অর্ডারের সময় আপডেট হয়েছে।',
        powered_by: '{{name}} দ্বারা চালিত',
        button_text: 'ট্র্যাক অর্ডার',
        subject_label: 'আপডেট করা প্রস্তুতির সময়',
        subject_label_delivery: 'আপডেট করা ডেলিভারির সময়',
        body_ready: 'আপনার অর্ডার এখন {{time}}-এ প্রস্তুত হবে।',
        body_delivery: 'আপনার অর্ডার এখন {{time}}-এ পৌঁছে দেওয়া হবে।',
    },
    order: {
        receipt: {
            est_ready_time: 'অনুমান। প্রস্তুত সময়',
            est_driver_pickup_time: 'অনুমান। ড্রাইভার পিকআপ সময়',
            est_delivery_time: 'অনুমান। ডেলিভারি সময়',
            tab_details: 'বিস্তারিত',
            tab_dishes: 'আইটেম',
            future_order: 'ভবিষ্যৎ আদেশ',
            reprint: 'রিপ্রিন্ট করুন',
            details: {
                order_no: 'অর্ডার নং',
                status: 'স্ট্যাটাস',
                placed: 'স্থাপন করা হয়েছে',
                due: 'ডিউ',
                due_asap: 'এখন / যত তাড়াতাড়ি সম্ভব',
                last_updated: 'সর্বশেষ আপডেট',
                total: 'মোট',
                type: 'টাইপ',
                origin: 'উৎপত্তি',
                table: 'টেবিল',
                number_of_people: 'মানুষের সংখ্যা',
                payment_method: 'পেমেন্ট পদ্ধতি',
                payment_status: 'পেমেন্ট স্ট্যাটাস',
                payment_currency: 'পেমেন্ট কারেন্সি',
                notes: 'নোট',
                name: 'নাম',
                email: 'ই-মেইল',
                phone: 'ফোন',
                distance: 'দূরত্ব',
                driving_time: 'ড্রাইভিং সময়',
                delivery_zone: 'জোন',
                delivery_address: 'ডেলিভারি ঠিকানা',
                delivery_provider: 'ডেলিভারি প্রদানকারী',
                delivery_tracking: 'ডেলিভারি ট্র্যাকিং',
                delivery_return_tracking: 'ট্র্যাক রিটার্ন',
                delivery_tracking_link: 'ট্র্যাক অর্ডার',
                tookan_status: 'টোকান স্ট্যাটাস',
                tookan_status_failed_book: 'বুক ডেলিভারি করা যায়নি',
                tookan_status_failed_update: 'বুকিং আপডেট করতে ব্যর্থ',
                tookan_status_success: 'ডেলিভারির জন্য বুক করা হয়েছে',
                store_address: 'দোকানের ঠিকানা',
                destination: 'গন্তব্য',
                estimated_arrival_time: 'আগমনের সময় অনুমান করুন',
                delivery_status: 'স্ট্যাটাস',
                delivery_track_your_order: 'আপনার অর্ডার ট্র্যাক',
                delivery_text: 'ডেলিভারি',
                arrival_date: 'আগমনের তারিখ',
            },
            dishes: {
                headings: {
                    quantity: 'পরিমাণ',
                    item: 'আইটেম',
                    price: 'দাম',
                },
                notes: 'নোট',
                remove_ingredients: 'উপাদানগুলি সরান',
            },
            status_update: {
                title: 'অর্ডার {{number}} আপডেট করা হয়েছে',
                body: 'আপনার অর্ডার স্থিতি {{status}} এ আপডেট করা হয়েছে',
            },
            wait_time_update: {
                title: 'অর্ডার {{number}} আপডেট করা হয়েছে',
                body: 'আপনার অর্ডার নির্ধারিত সময় আপডেট করা হয়েছে',
            },
            delivery_update: {
                title: 'অর্ডার {{number}} আপডেট করা হয়েছে',
                body: 'আপনার অর্ডার ডেলিভারির জন্য বুক করা হয়েছে. রিয়েল-টাইম ট্র্যাকিং লিঙ্ক দেখুন',
            },
            payment_status_update: {
                title: 'অর্ডার {{number}} আপডেট করা হয়েছে',
                body: 'আপনার অর্ডার পেমেন্ট স্থিতি আপডেট করা হয়েছে.',
            },
            email_new_order_restaurant: {
                subject: 'নতুন অর্ডার ({{number}}) - {{name}}',
                powered_by: '{{name}} দ্বারা চালিত',
                overview: 'নতুন অর্ডার বিজ্ঞপ্তি',
                title: '{{name}} এ নতুন অর্ডার দেওয়া হয়েছে',
                subtitle: 'অর্ডার নম্বর {{number}}',
                description: 'আপনার অ্যাডমিন ড্যাশবোর্ডের মাধ্যমে বিশদ এবং আপডেটগুলি দেখুন৷',
                button_text: 'ট্র্যাক অর্ডার',
                track_delivery_button_text: 'ট্র্যাক ডেলিভারি',
            },
            email_new_order_customer: {
                subject: 'অর্ডার রসিদ ({{number}})',
                powered_by: '{{name}} দ্বারা চালিত',
                overview: 'নতুন অর্ডার বিজ্ঞপ্তি',
                title: '{{name}} এ নতুন অর্ডার দেওয়া হয়েছে',
                subtitle: 'অর্ডার নম্বর {{number}}',
                description: 'আপনার রিয়েল-টাইম অনলাইন রসিদের মাধ্যমে বিবরণ এবং আপডেট দেখুন',
                button_text: 'ট্র্যাক অর্ডার',
                track_delivery_button_text: 'ট্র্যাক ডেলিভারি',
            },
            email_order_completed_by_customer: {
                subject: 'অর্ডার ({{number}}) গ্রাহক দ্বারা সম্পন্ন হয়েছে৷',
                powered_by: '{{name}} দ্বারা চালিত',
                overview: 'অর্ডার সম্পন্ন বিজ্ঞপ্তি',
                title: '{{name}} এ অর্ডার সম্পন্ন হয়েছে',
                subtitle: 'অর্ডার নম্বর {{number}}',
                description: 'আপনার ড্যাশবোর্ডের মাধ্যমে বা এ রসিদ ব্যবহার করে আপনার অর্ডারের বিশদ বিবরণ এবং আপডেটগুলি দেখুন৷',
            },
        },
        totals: {
            tax: '{{name}} ({{percent}}%)',
            tax_in_prices: '{{name}} ({{percent}}%) ইনক। দামে',
            fee: '{{name}} ({{value, currency}} + {{percent}}%)',
            fee_percent: '{{name}} ({{percent}}%)',
            fee_fixed: '{{name}}',
            delivery_fee: 'ডেলিভারি ফি',
            delivery_fee_offset: 'ডেলিভারি ফি ডিসকাউন্ট',
            delivery_fee_total: 'ডেলিভারি ফি মোট',
            promo: 'ছাড়: {{name}} ({{value, currency}} + {{percent}}% ছাড়)',
            promo_percent: 'ছাড়: {{name}} ({{percent}}%)',
            promo_fixed: 'ছাড়: {{name}}',
            promo_none: 'ছাড়: {{name}}',
            cart: 'কার্ট',
            tip: 'অর্ডার টিপ',
            total: 'মোট',
        },
        status: {
            unconfirmed: 'আন-কনফার্ম',
            awaiting_payment: 'পেমেন্টের অপেক্ষায়',
            confirmed: 'নিশ্চিত করা হয়েছে',
            ready: 'প্রস্তুত',
            on_route: 'রুটে',
            complete: 'সম্পূর্ণ',
            cancelled: 'বাতিল',
            seated: 'বসানো হয়েছে',
        },
        searching: {
            lalamove_search_placeholder: 'Lalamove ডেলিভারি আইডি দ্বারা অর্ডার অনুসন্ধান করুন',
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: 'অনুপলব্ধ',
                },
            },
            dish: {
                no_stock: 'স্টক আউট',
                not_available: 'উপলব্ধ নয়',
            },
        },
    },
    admin: {
        registration: {
            register_confirmation_code_subject: 'ই-মেইল নিশ্চিতকরণ কোড',
            register_confirmation_code_email: 'আপনার ইমেল নিশ্চিতকরণ কোড হল {{confirmation_code}} (24 ঘন্টার মধ্যে মেয়াদ শেষ হবে)',
            register_confirmation_code_email_onbehalf: 'আপনার ইমেল নিশ্চিতকরণ কোড হল {{confirmation_code}} (24 ঘন্টার মধ্যে মেয়াদ শেষ হবে)। এটি ইমেল ঠিকানা, {{email}} এর জন্য।',
        },
    },
};
//# sourceMappingURL=bn.js.map